/**
 * Inline variant panel toggle for product cards.
 *
 * - Click on .product-card__variants-toggle → opens the variant panel
 * - Click outside → closes any open panel (capture phase, immune to stopPropagation)
 * - Successful add to cart (variant:add event) → closes the panel
 */

// Runs in capture phase (before any other handler, including Shopify's)
// so stopPropagation() calls elsewhere can't prevent the close.
document.addEventListener('click', (event) => {
  document.querySelectorAll('.product-card__quick-buy.variants-visible').forEach((panel) => {
    if (!panel.contains(event.target)) {
      panel.classList.remove('variants-visible');
    }
  });
}, true);

// Toggle open/close when clicking the "Ajouter au panier" button
document.addEventListener('click', (event) => {
  const path = event.composedPath();
  const toggleBtn = path.find(el => el.classList && el.classList.contains('product-card__variants-toggle'));
  
  if (!toggleBtn) return;

  // Prevent default to avoid any potential form submission if the button is inside a form
  event.preventDefault();

  const quickBuy = toggleBtn.closest('.product-card__quick-buy');
  if (quickBuy) {
    const isCurrentlyVisible = quickBuy.classList.contains('variants-visible');
    
    // Close other open panels first
    if (!isCurrentlyVisible) {
      document.querySelectorAll('.product-card__quick-buy.variants-visible').forEach(p => p.classList.remove('variants-visible'));
    }

    quickBuy.classList.toggle('variants-visible');
  }
});

// Close panel after a variant is successfully added to cart
document.addEventListener('variant:add', (event) => {
  const quickBuy = event.target.closest('.product-card__quick-buy');
  if (quickBuy) {
    quickBuy.classList.remove('variants-visible');
  }
});

// Close panel when the mouse truly leaves the product card
document.addEventListener('mouseout', (event) => {
  const card = event.target.closest('.product-card');
  if (!card) return;
  if (card.contains(event.relatedTarget)) return;
  const quickBuy = card.querySelector('.product-card__quick-buy.variants-visible');
  if (quickBuy) {
    quickBuy.classList.remove('variants-visible');
  }
});

// Mobile: reveal secondary image and button on touch/swipe (pointer: coarse)
if (window.matchMedia('(pointer: coarse)').matches) {
  let preventNextClick = false;

  function setActiveCard(card) {
    document.querySelectorAll('.product-card.is-active').forEach((c) => {
      if (c !== card) {
        c.classList.remove('is-active');
        c.querySelector('.product-card__figure')?.classList.remove('is-active');
      }
    });
    if (card) {
      card.classList.add('is-active');
      card.querySelector('.product-card__figure')?.classList.add('is-active');
    }
  }

  // Touchstart: immediately activate card under finger
  document.addEventListener('touchstart', (event) => {
    if (event.target.closest('.product-card__quick-buy')) {
      preventNextClick = false;
      return;
    }

    const card = event.target.closest('.product-card');

    if (!card) {
      document.querySelectorAll('.product-card.is-active').forEach((c) => {
        c.classList.remove('is-active');
        c.querySelector('.product-card__figure')?.classList.remove('is-active');
      });
      preventNextClick = false;
      return;
    }

    // First touch on an inactive card — activate and block the resulting click (navigation)
    preventNextClick = !card.classList.contains('is-active');
    setActiveCard(card);
  }, { passive: true });

  // Touchmove: follow finger across cards
  document.addEventListener('touchmove', (event) => {
    const touch = event.touches[0];
    const el = document.elementFromPoint(touch.clientX, touch.clientY);
    const card = el?.closest('.product-card');
    if (card) setActiveCard(card);
  }, { passive: true });

  // Click: block navigation when card was just activated by the touch
  document.addEventListener('click', (event) => {
    if (event.target.closest('.product-card__quick-buy')) return;

    const card = event.target.closest('.product-card');

    if (!card) {
      document.querySelectorAll('.product-card.is-active').forEach((c) => {
        c.classList.remove('is-active');
        c.querySelector('.product-card__figure')?.classList.remove('is-active');
      });
      return;
    }

    if (preventNextClick) {
      event.preventDefault();
      preventNextClick = false;
    }
  });
}
